import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { StockWaterfallView } from './StockWaterfall.constants'

type StockWaterfallToggleProps = {
  value: StockWaterfallView
  onChange: (view: StockWaterfallView) => void
  disabled?: boolean
}

// The transition switch, shown on v2 plans only. Remove it once the default
// has flipped to New and the transition is done.
export const StockWaterfallToggle = ({
  value,
  onChange,
  disabled = false,
}: StockWaterfallToggleProps) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    disabled={disabled}
    aria-label="Stock projection chart"
    onChange={(_, view: StockWaterfallView | null) => view && onChange(view)}
    sx={{ height: '40px', mr: 2 }}
  >
    <ToggleButton value="new">New</ToggleButton>
    <ToggleButton value="classic">Classic</ToggleButton>
  </ToggleButtonGroup>
)
